export default "__VITE_ASSET__BpuLZubT__"